exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ContextMenu__container{font:var(--main-font);position:absolute;padding:0;border-radius:4px;background:#fff;border:1px solid #aaa;list-style:none;opacity:1;white-space:nowrap;visibility:visible;transition:opacity .2s ease,visibility .2s ease}.ContextMenu__hidden{opacity:0;visibility:hidden}", ""]);

// Exports
exports.locals = {
	"container": "ContextMenu__container",
	"hidden": "ContextMenu__hidden"
};